import {ICoverImage, IDocument} from "./interfaces";

export enum CoverDocumentType {
    CATALOGS_AND_BROCHURES,
    CATALOGS,
    BROCHURES
}

export function coverImagesForDocument(coverImages: ICoverImage[], document?: IDocument): ICoverImage[] {
    if (document == undefined) {
        return [];
    }
    switch (document.type) {
        case "Brochure":
            return coverImages.filter(c => (c.coverDocumentType == CoverDocumentType.BROCHURES)
                || (c.coverDocumentType == CoverDocumentType.CATALOGS_AND_BROCHURES));
        case "Catalog":
            return coverImages.filter(c => (c.coverDocumentType == CoverDocumentType.CATALOGS)
                || (c.coverDocumentType == CoverDocumentType.CATALOGS_AND_BROCHURES));
        default:
            break;
    }
    return coverImages;
}



// WEBPACK FOOTER //
// ./src/infrastructure/CoverImageTypes.ts